import { PROCESS_STEPS } from "../../data/content";

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="py-20 md:py-32 bg-ink-mist"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-6">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Our Process
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              Seven steps.
              <br />
              <span className="font-serif-italic font-normal text-ink-mid">
                From inspection to handover.
              </span>
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 self-end text-ink-muted leading-relaxed">
            The process is deliberate and consistent — whether the scope is
            epoxy flooring, waterproofing or painting. Every step protects the
            final quality of the finish.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-ink-line border border-ink-line">
          {PROCESS_STEPS.map((s, idx) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className={`bg-white p-6 md:p-8 group hover:bg-ink hover:text-white transition-colors ${
                idx === 6 ? "md:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="flex items-baseline gap-4 mb-6">
                <div className="font-display text-4xl md:text-5xl text-ink group-hover:text-white leading-none">
                  {s.n}
                </div>
                <div className="h-[1px] flex-1 bg-ink-line group-hover:bg-white/30" />
              </div>
              <h3 className="font-display text-lg md:text-xl text-ink group-hover:text-white leading-tight">
                {s.title}
              </h3>
              <p className="text-sm text-ink-muted group-hover:text-white/70 mt-2 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
